import CustomEvent from 'lib/CustomEvent';
import Main from 'controllers/Main';
import Screen from 'controllers/Screen';
import Device from 'controllers/Device';
import Math_ from 'utils/Math';


export default new class Scroll extends CustomEvent {


	constructor() {
		super();

		this.IS_SMOOTH = true;

		this.E = {
			SCROLL_COMPLETE: 'scrollcomplete'
		};

		this.smooth = null;

		this.y = null; // scroll Y
		this.yI = null; // scroll Y with inertia
		this.v = null; // scroll velocity
	}


	init($window = $(window)) {
		this._initDOM($window);
		this._initEl();
		this._bindEvents();

		this._disableScrollRestoration();
	}


	_initDOM($window) {
		this.$window = $window;
	}


	_initEl() {
	}


	_bindEvents() {
		Main.on(Main.E.RAF, this._raf, this);
		Screen.on(Screen.E.RESIZE, this._resize, this);
	}


	_disableScrollRestoration() {
		if ('scrollRestoration' in history)
			history.scrollRestoration = 'manual';
	}

	_resize() {
		if (this.smooth) {
			ScrollTrigger.refresh(true);
		}
	}


	_raf() {
		this.y = this.$window[0].scrollY;
	}


	initSmooth($wrapper, $content) {
		if (this.smooth) {
			this.smooth.kill();
		}
		this.smooth = ScrollSmoother.create({
			wrapper: $wrapper,
			content: $content,
			smooth: this.IS_SMOOTH ? 2 : 0, // default 0.8
			normalizeScroll: false,
			ignoreMobileResize: true,
			effects: true,
			onUpdate: this._onSmoothUpdate.bind(this),
			onStop: this._onSmoothStop.bind(this)
		});
		this.pauseSmooth();
	}

	resize() {
		this._resize();
	}


	_onSmoothUpdate(self) {
		this._updateProps(self);
	}


	_onSmoothStop(self) {
		this._updateProps(self, true);
	}


	_updateProps(self, roundY = false) {
		if (typeof self == 'number') {
			this.yI = Math.round(self);
			this.v = 0;
		} else {
			this.yI = roundY ? Math.round(self.scrollTop()) : self.scrollTop();
			this.v = self.getVelocity();
		}
	}


	pauseSmooth(paused = true) {
		if (!this.smooth)
			return;

		this.smooth.paused(paused);
	}


	killSmooth() {
		if (!this.smooth)
			return;

		this.smooth.kill();
	}


	scrollTo(value, type = 'default', position = 'top 199px', duration = 1, ease = 'power3.inOut', onComplete = false) {
		if (!this.smooth)
			return;

		if (type === 'default') {
			this._updateProps(value);
			this.smooth.scrollTop(value);
			this._resize();
		} else if (type === 'smooth')
			this.smooth.scrollTo(value, true, position);
		else if (type === 'ease')
			this.tw.scrollTo = gsap.to(this.smooth, {
				scrollTop: value,
				duration: duration,
				ease: ease,
				onComplete: () => {
					if (onComplete)
						this.emit(this.E.SCROLL_COMPLETE);
				}
			});
	}


}
